import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';
import { createProducts, updateRoles } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { Roles } from './RolesColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import axios from 'axios';
import SpinnerForm from '../spinnner/SpinnerForm';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showUpdateRolesDrawer: boolean
    setShowUpdateRolesDrawer: React.Dispatch<React.SetStateAction<boolean>>
    Roles: Roles
    getRoles: any
    setRolesData: React.Dispatch<React.SetStateAction<Roles | undefined>>
}
const UpdateRolesDrawer: React.FC<ProductsDrawerProps> = ({ showUpdateRolesDrawer, setShowUpdateRolesDrawer, Roles, getRoles, setRolesData }) => {
    const onCLose = () => {
        setRolesData(undefined)
        setShowUpdateRolesDrawer(false)
    }
    const [submitting, setSubmitting] = useState(false)
    const [loadingForm, setLoadingForm] = useState(true)
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()



    useEffect(() => {
        const setFormValues = async () => {
            form.setFieldsValue(Roles)
            setLoadingForm(false)
        }

        if (Roles) {
            setFormValues()
        }
    }, [Roles, form])

    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (roles: Roles) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.put(`/api/v1/roles/${roles.id}`, roles, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "Role successfully updated",
                    `${roles.name} was updated`,
                    'topRight'
                )
            }
            getRoles()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2))
    }


    return <Drawer
        title="Update  roles"
        width={720}
        onClose={onCLose}
        open={showUpdateRolesDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >
        {(loadingForm) ? (
            <div>
                <SpinnerForm />
            </div>
        ) : (
            < Form layout="vertical"
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                form={form}
                hideRequiredMark>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="name"
                            label="name"
                            rules={[{ required: true, message: 'Please enter name' }]}
                        >
                            <Input
                                placeholder="Please enter name"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="id"
                            label="id"
                            hidden={true}
                            rules={[{ required: true, message: 'Please enter description ' }]}
                        >
                            <Input
                                placeholder="Please enter description"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    {submitting && <Spin indicator={antIcon} />}
                </Row>
            </Form>
        )}

    </Drawer >
}

export default UpdateRolesDrawer;


